module.exports = __webpack_public_path__ + "img/26.fe111dff.jpeg";